export default class DeploymentConfiguration {
  condition
  constructor(condition) {
    this.condition = condition;
  }
}
